import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiImage, FiLayers, FiZap } = FiIcons;

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="bg-blue-600 p-2 rounded-lg">
                <SafeIcon icon={FiImage} className="text-white text-xl" />
              </div>
              <div>
                <span className="text-xl font-bold">{t('header.brandName')}</span>
                <div className="text-sm text-gray-400">{t('header.brandSubtitle')}</div>
              </div>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              {t('footer.companyInfo')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                  {t('navigation.home')}
                </Link>
              </li>
              <li>
                <Link to="/features" className="text-gray-300 hover:text-white transition-colors">
                  {t('navigation.features')}
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-gray-300 hover:text-white transition-colors">
                  {t('navigation.howItWorks')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">
                  {t('navigation.privacy')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Tools */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.tools')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors flex items-center">
                  <SafeIcon icon={FiImage} className="mr-2 text-sm" />
                  {t('navigation.singleImageResize')}
                </Link>
              </li>
              <li>
                <Link to="/batch-resize" className="text-gray-300 hover:text-white transition-colors flex items-center">
                  <SafeIcon icon={FiLayers} className="mr-2 text-sm" />
                  {t('navigation.batchImageResize')}
                </Link>
              </li>
              <li>
                <Link to="/compress" className="text-gray-300 hover:text-white transition-colors flex items-center">
                  <SafeIcon icon={FiZap} className="mr-2 text-sm" />
                  {t('navigation.singleImageCompress')}
                </Link>
              </li>
              <li>
                <Link to="/batch-compress" className="text-gray-300 hover:text-white transition-colors flex items-center">
                  <SafeIcon icon={FiLayers} className="mr-2 text-sm" />
                  {t('navigation.batchImageCompress')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            {t('footer.copyright')}
          </p>
          <p className="text-gray-400 text-sm mt-2 md:mt-0">
            {t('footer.madeWith')}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;